if (!customElements.get('filtrare-matching-set')) {
  customElements.define('filtrare-matching-set', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.choices = [...this.querySelectorAll('[data-choice]')];
      this.button = this.querySelector('.fms__add');
      this.status = this.querySelector('.fms__status');
      this.selected = [true, true, true];
      this.busy = false;
      this.abort = new AbortController();
      this.form = document.getElementById(this.dataset.form);
      this.main = this.closest('product-info');
      const opts = { signal: this.abort.signal };
      this.form?.addEventListener('change', e => {
        if (e.target.name === 'id') this.sync(e.target.value);
      }, opts);
      this.main?.addEventListener('change', e => {
        if (e.target.closest('variant-selects')) {
          this.pending = true;
          this.render();
        }
      }, opts);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId === this.dataset.section) this.sync(data.variant?.id);
        });
      }
      this.choices.forEach((input, i) => input.addEventListener('change', () => {
        this.selected[i] = input.checked;
        this.render();
      }, opts));
      this.button.addEventListener('click', () => this.add(), opts);
      this.sync(this.form?.querySelector('[name="id"]')?.value || this.config.initial);
    }
    disconnectedCallback() { this.abort?.abort(); this.unsubscribe?.(); }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.config.currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    sync(id) {
      const [brewer, mug, filters] = this.config.products;
      const variant = brewer.variants.find(v => String(v.id) === String(id));
      const normalize = value => String(value || '').trim().toLocaleLowerCase();
      const colour = variant?.options[this.config.colourIndex];
      const mugIndex = mug?.options.findIndex(o => /^(colou?r)$/i.test(typeof o === 'string' ? o : o.name)) ?? -1;
      const match = colour && mug?.variants.find(v => normalize(v.options[Math.max(0, mugIndex)]) === normalize(colour));
      this.variants = [variant, match || null, filters?.variants.find(v => v.available) || filters?.variants[0]];
      this.pending = false;
      this.render();
    }
    render() {
      if (!this.variants) return;
      const strings = this.config.strings;
      let total = 0, count = 0;
      this.variants.forEach((variant, i) => {
        const product = this.config.products[i];
        const available = Boolean(variant?.available);
        const included = this.selected[i] && available;
        this.choices[i].disabled = !available || this.busy;
        this.choices[i].checked = included;
        this.querySelector(`[data-tile="${i}"]`).toggleAttribute('data-excluded', !included);
        this.querySelector(`[data-variant="${i}"]`).textContent = variant?.title === 'Default Title' ? '' : variant?.title || '';
        this.querySelector(`[data-availability="${i}"]`).textContent = available ? '' : i === 1 && !variant ? strings.noMatch : strings.unavailable;
        this.querySelector(`[data-price="${i}"]`).textContent = variant ? this.money(variant.price) : '';
        const link = this.querySelector(`[data-link="${i}"]`);
        if (product) link.href = `${window.Shopify?.routes?.root || '/'}products/${product.handle}${variant ? '?variant=' + variant.id : ''}`;
        const image = link.querySelector('img');
        const source = variant?.featured_image?.src || product?.featured_image;
        if (image && source) { image.removeAttribute('srcset'); image.src = source + (source.includes('?') ? '&' : '?') + 'width=320'; }
        if (included) { total += variant.price; count++; }
      });
      this.button.disabled = this.busy || this.pending || !count;
      this.querySelector('[data-button]').textContent = this.busy ? strings.adding : this.pending ? strings.choose : !count ? strings.none : `${count === 3 ? strings.all : strings.selected} · ${this.money(total)} ${this.config.currency}`;
    }
    async add() {
      if (this.busy || this.pending) return;
      const items = this.variants.flatMap((v, i) => v?.available && this.selected[i] ? [{ id: v.id, quantity: 1 }] : []);
      if (!items.length) return;
      this.busy = true;
      this.status.textContent = '';
      this.render();
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.config.strings.error);
        window.location.assign(root + 'cart');
      } catch (error) {
        this.status.textContent = error.message || this.config.strings.error;
        this.busy = false;
        this.render();
      }
    }
  });
}
